import { render, staticRenderFns } from "./CardHeader.vue?vue&type=template&id=1e77d3ce"
import script from "./CardHeader.vue?vue&type=script&setup=true&lang=ts"
export * from "./CardHeader.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports